import cx from 'classnames';
import { FormLabel } from './FormLabel';
import { isValidHex } from 'react-color/lib/helpers/color';

import styles from './ColorInput.module.scss';
import { useEffect, useRef, useState } from 'react';
import Button from '../../../Button/Button';

export const ColorInput = ({
  label,
  value,
  name,
  className,
  InputContainerProps,
  readonly,
  onChange,
  onColorClick,
  undoRedoAction,
  render,
  showPredefinedColors,
  ...rest
}) => {
  const [localValue, setLocalValue] = useState(value);
  const undoValueRef = useRef(null);
  const lastValidValueRef = useRef(value);
  const [focused, setFocused] = useState(false);

  const predefinedColors = [
    {
    label:"3000K",
    color:"#FFB96F"
  },
    {
    label:"4500K",
    color:"#FFE2C4"
  },
    {
    label:"6000K",
    color:"#E8ECF0"
  },
]

  useEffect(() => {
    if (focused) return;
    if (value !== localValue) {
      lastValidValueRef.current = value;
      setLocalValue(value);
    }
  }, [value])


  const handleFocus = () => {
    undoValueRef.current = value;
    setFocused(true)
  }

  const handleBlur = () => {
    setFocused(false)
    setLocalValue(lastValidValueRef.current)

    if (lastValidValueRef.current === undoValueRef.current) {
      // value was not changed, there is no reason to save it into undo/redo
      return;
    }

    undoRedoAction?.({
      name,
      prevValue: undoValueRef.current,
      nextValue: lastValidValueRef.current,
    });
  }


  const handleChange = (event, _value) => {
    const value = _value || event.target.value
    console.log('change, value', value)
    let normalizedValue = value.trim();
    normalizedValue = normalizedValue.replace(/[^#0-9a-f]/gi, '')

    if (normalizedValue.length > 0 && !normalizedValue.startsWith('#')) {
      normalizedValue = `#${normalizedValue}`;
    };
    if (normalizedValue.split('#').length > 2) return;

    // const hexAllowedRegex = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i

    if (normalizedValue.length <= 7) {
      setLocalValue(normalizedValue);
    }

    if (
      normalizedValue.startsWith('#') &&
      (normalizedValue.length === 7 || normalizedValue.length === 4) &&
      isValidHex(normalizedValue)
    ) {
      lastValidValueRef.current = normalizedValue;
      onChange?.(normalizedValue, event);
    } else {
      event.preventDefault();
    }
  };

  if (render) {
    return render({
      value: localValue,
      onChange: handleChange,
      onBlur: handleBlur,
      onFocus: handleFocus,
    })
  }

  return (
    <div className={cx(styles.root, className, showPredefinedColors ? "w-100": "")} {...rest}>
      {label && <FormLabel>{label}</FormLabel>}
      {showPredefinedColors ? <div className='d-flex gap-2 pb-3'>
        {predefinedColors?.map(color => <Button
          className={`w-100 ${localValue !== color.color ? styles.button : ""}`}
          onClick={
            (e) => handleChange(e, color?.color)
          }
        >{color.label}</Button>)}
      </div>
        : null}
      <div className={cx(styles.inputContainer, showPredefinedColors ? "w-50": "")} {...InputContainerProps}>
        <input
          // className={styles.input}
          type="text"
          value={localValue}
          name={name}
          onChange={handleChange}
          color={value}
          onBlur={handleBlur}
          onFocus={handleFocus}
        />
        <div
          className={styles.colorPlaceholder}
          style={{ backgroundColor: value, cursor: onColorClick ? 'pointer' : undefined }}
          onClick={onColorClick}></div>
      </div>
    </div>
  );
};
